import { render, staticRenderFns } from "./ButtonList.form.vue?vue&type=template&id=664fea33&scoped=true&"
import script from "./ButtonList.form.vue?vue&type=script&lang=js&"
export * from "./ButtonList.form.vue?vue&type=script&lang=js&"
import style0 from "./ButtonList.form.vue?vue&type=style&index=0&id=664fea33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664fea33",
  null
  
)

export default component.exports